module.exports = __webpack_public_path__ + "07_long_gray.01d4697f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/07_long_gray.png
// module id = VAZi
// module chunks = 0